import { identify, makeRequest, Service } from 'utils/http';
import { DocumentRequestBase } from 'services/documents/types';

type Data = Pick<DocumentRequestBase, 'templateId'>;

export async function createDocumentApi(data: Data) {
  return makeRequest(Service.createDocument(data.templateId, await identify()));
}
